import { CampaignDetailModel } from '@urbanx/agx.campaigns.client'
import CampaignsService from 'services/campaignsService'

const getCampaignById = async (
  getAuthToken: () => Promise<string>,
  campaignId?: string
): Promise<CampaignDetailModel | undefined> => {
  if (!campaignId) return

  const token = await getAuthToken()
  const service = new CampaignsService(token)

  const result = await service.campaignsService.get('StaffGetCampaign', {
    CampaignId: campaignId,
  })

  return result.data
}

export default getCampaignById
